import {Link} from 'react-router-dom';
import s from './TourCardIndu.module.scss';
import StarRating from '../../components/StarRating/StarRating';
import LazyLoad from 'react-lazyload';
import ImageWithPlaceholder from "../Image/ImageWithPlaceholder";

const TourCardIndividual = ({item,loading}) => {
    const SkeletonCard = () => {
        return (
            <div className={`${s.cards} ${s.skeleton}`}>
                <div className={s.imageWrapper}>
                    <div className={s.skeletonImage}></div>
                </div>

                <div className={s.detailsContainer}>
                    <div className={s.skeletonTitle}></div>

                    <div className={s.skeletonRating}></div>

                    <div className={s.tags}>
                        <div className={s.skeletonTag}></div>
                        <div className={s.skeletonTag}></div>
                        <div className={s.skeletonTag}></div>
                    </div>

                    <div className={s.skeletonText}></div>
                    <div className={s.skeletonText}></div>

                    <div className={s.spacer}></div>

                    <div className={s.skeletonPrice}></div>
                </div>
            </div>
        );
    };
    if (loading) return <SkeletonCard />;

    if (!item) return null;
    const tourId = item.tour_id || item.tourId;
    const rezdyId = item.rezdy_id || item.rezdyId;
    const tourCode =  item.tour_code;
    const image = item.images?.[0] ?? item.image1;
    const title = item.title;
    const rating = item.rating ?? 0;
    const reviewCount = item.reviewCount ?? item.review_count ?? 0;
    const tags = item.tags ?? [];
    const details = item.details ?? '';

    const salePrice = Math.floor(item.salePrice ?? item.sale_price ?? 0);
    const regularPrice = Math.floor(item.regularPrice ?? item.regular_price ?? 0);
    const discountRate = regularPrice > 0 ? Math.round(((regularPrice - salePrice) / regularPrice) * 100) : 0;

    const formatPrice = (price) =>
        new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'AUD'
        }).format(price || 0);

    return (
        <div>
            <div  className={s.cards}>
                <div className={s.imageWrapper}>
                    <Link to={`/tours/${tourId}`}>
                        <LazyLoad height={200} offset={100} once>
                            <ImageWithPlaceholder  src={image} alt={title} className={s.image} />
                        </LazyLoad>
                    </Link>
                </div>

                <div className={s.detailsContainer}>
                    <Link to={`/tours/${tourId}`}>
                        <h3 className={s.title}>{title}</h3>

                    </Link>
                    {tourCode && <p className={s.tourCode}>TOUR CODE: {tourCode}</p>}
                    <div className={s.rating}>
                        <StarRating score={rating}/>
                        <p className={s.rate}>{rating}</p>
                        <p className={s.count}>({reviewCount})</p>
                    </div>

                    <Link
                        to={`/review/${tourId}`}
                        className={s.ratingLink}
                        state={{
                            breadcrumbItems: [
                                {name: 'ホーム', link: '/'},
                                {name: `${title}の口コミ`, link: ''}
                            ]
                        }}
                    />

                    <div className={s.tags}>
                        {tags.map((tag, tagIndex) => (
                            <span key={tagIndex} className={s.tag}>
                      {tag.name ?? tag}
                    </span>
                        ))}
                    </div>

                    <p className={s.details}>{details}</p>
                    <div className={s.spacer}></div>

                    <div className={s.prices}>
                        {discountRate>0?   <p className={s.salePrice}>{formatPrice(salePrice)}</p>:<p className={s.salePrice}>{formatPrice(regularPrice)}</p>}
                        {discountRate>0? <p className={s.regularPrice}>{formatPrice(regularPrice)}</p>:""}
                        {discountRate>0?<div className={s.label}>{discountRate}%</div>:""}
                    </div>
                </div>
            </div>
        </div>

    );
};

export default TourCardIndividual;
